import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION11: PdfComponent = {
  type: 'section',
  id: 'iars11',
  title: '11. Indemnity',
  content: [
    {
      type: 'altText',
      id: 'iars11bullets',
      content: [
        'The Introducer agrees to fully ',
        'indemnify',
        ' the Principal for any losses (including consequential loss) arising from its conduct or that of its employees or agents.',
      ],
      boldFirst: false,
    },
  ],
};
